/**
 * Auth API — fetches the current user's resolved identity from the backend.
 *
 * The single consumer is `AuthContext`, which calls `fetchMe` directly via
 * `queryClient.fetchQuery({ queryKey: AUTH_ME_KEY, queryFn: fetchMe })`.
 *
 * We deliberately do NOT export a `useMe` hook here — having two ways to
 * read the same data invites cache drift (different staleTime/retry
 * semantics). All identity reads go through `useAuth()` from
 * `@/context/AuthContext`.
 */

import { api } from '@core/api/client';
import type { AuthUser } from '@/types';

export const AUTH_ME_KEY = ['auth', 'me'] as const;

/** GET /v1/auth/me — returns the resolved AuthContext from the backend. */
export async function fetchMe(): Promise<AuthUser> {
  return api.get<AuthUser>('/v1/auth/me');
}
